import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["dropdown", "selectedLabel", "arrow"]

  connect() {
    this.outsideClickListener = this.handleOutsideClick.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    const isOpen = !this.dropdownTarget.classList.contains("hidden")
    this.closeAllDropdowns()
    if (!isOpen) {
      this.dropdownTarget.classList.remove("hidden")
      this.arrowTarget.classList.add("rotate-180")
      document.addEventListener("click", this.outsideClickListener)
    } else {
      this.dropdownTarget.classList.add("hidden")
      this.arrowTarget.classList.remove("rotate-180")
      document.removeEventListener("click", this.outsideClickListener)
    }
  }

  select(event) {
    const label = event.target.dataset.label
    const value = event.target.value
    this.selectedLabelTarget.textContent = label
    this.dropdownTarget.classList.add("hidden")
    this.arrowTarget.classList.remove("rotate-180")
    document.removeEventListener("click", this.outsideClickListener)

    // Update URL with sort param and reload
    const url = new URL(window.location.href)
    url.searchParams.set('sort', value)
    Turbo.visit(url.toString())
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
      this.arrowTarget.classList.remove("rotate-180")
      document.removeEventListener("click", this.outsideClickListener)
    }
  }

  closeAllDropdowns() {
    document.querySelectorAll('[data-controller="sort-dropdown"]').forEach(el => {
      if (el !== this.element) {
        const dropdown = el.querySelector('[data-sort-dropdown-target="dropdown"]')
        const arrow = el.querySelector('[data-sort-dropdown-target="arrow"]')
        if (dropdown) dropdown.classList.add("hidden")
        if (arrow) arrow.classList.remove("rotate-180")
      }
    })
  }
}